// Locale-aware formatters. Keep these tiny — pages import per-need.

const localeMap = { pt: "pt-BR", en: "en-US" };

export function bcp47(loc) {
  return localeMap[loc] || localeMap.pt;
}

export function formatCurrency(value, currency = "BRL", loc = "pt") {
  const cur = String(currency || "BRL").toUpperCase();
  try {
    return new Intl.NumberFormat(bcp47(loc), {
      style: "currency",
      currency: cur,
      maximumFractionDigits: cur === "BRL" ? 2 : 0,
    }).format(Number(value) || 0);
  } catch {
    return `${cur} ${(Number(value) || 0).toFixed(2)}`;
  }
}

export function formatDate(iso, loc = "pt", opts = { day: "2-digit", month: "short", year: "numeric" }) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString(bcp47(loc), opts); }
  catch { return String(iso).slice(0, 10); }
}

export function formatNumber(n, loc = "pt", opts = {}) {
  try { return new Intl.NumberFormat(bcp47(loc), opts).format(Number(n) || 0); }
  catch { return String(n); }
}

export function formatDateTime(iso, loc = "pt") {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(bcp47(loc), {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch { return String(iso); }
}
